class FbBlock extends HTMLElement {
  connectedCallback() {
    this.#initLike();
  }

  #initLike() {
    const like = this.querySelector('[data-fb-like]');
    const count = this.querySelector('[data-fb-reaction-count]');
    if (!like || !count || like.dataset.initialized === 'true') return;

    like.dataset.initialized = 'true';

    like.addEventListener('click', (event) => {
      event.preventDefault();

      const current = parseInt(count.textContent, 10) || 0;
      const isPressed = like.getAttribute('aria-pressed') === 'true';

      if (isPressed) {
        count.textContent = String(Math.max(0, current - 1));
        like.setAttribute('aria-pressed', 'false');
      } else {
        count.textContent = String(current + 1);
        like.setAttribute('aria-pressed', 'true');
      }
    });
  }
}

if (!customElements.get('fb-block')) {
  customElements.define('fb-block', FbBlock);
}
